import { Skeleton } from '@/components/ui/skeleton';

export const HeaderProfileBlockSkeleton = () => {
  return (
    <div className="flex items-center space-x-4">
      <div className="flex items-center gap-2 p-2 border rounded-md w-[220px]">
        {/* Скелетон для аватара */}
        <Skeleton className="h-8 w-8 rounded-full" />
        {/* Скелетон для текста */}
        <div className="space-y-2 flex-1">
          <Skeleton className="h-4 w-[140px]" />
        </div>
        {/* Скелетон для стрелки */}
        <Skeleton className="h-4 w-4" />
      </div>
    </div>
  );
};
